import { request } from '../utils/request';
import { formApi } from '../config/urlConfig'
/**
 * 新增表单数据
 * @param data 表单数据
 */
export const addDomainData = (data: any) =>
    request({
        url: `${formApi}/domain_data/insert`,
        method: 'post',
        data
    })

/**
 * 自定义按钮调用fun
 * @param data 表单数据
 */
export const customBtnCallFun = (data: any) =>
  request({
    url: `${formApi}/domain_data/customBtnCallFun`,
    method: 'post',
    data
  })

export const callFunPublic = (data: any) =>
  request({
    url: `${formApi}/domain_data/callFunPublic`,
    method: 'post',
    data
  })

/**
 * 根据流程id新增或更新
 * @param data 表单数据
 */
export const saveDomainData = (data: any) =>
    request({
        url: `${formApi}/domain_data/save`,
        method: 'post',
        data
    })

/**
 * 根据id修改表单数据
 * @param data 带_id的新数据
 */
export const updateDomainData = (data: any) =>
    request({
        url: `${formApi}/domain_data/update`,
        method: 'post',
        data
    })

/**
 * 批量修改保存表单数据
  */
export const batchReplaceDomainData = (data: any) =>
    request({
        url: `${formApi}/domain_data/batchReplace`,
        method: 'post',
        data
    })


/**
 * 根据id删除表单数据
 * @param data _id
 */
export const deleteDomainData = (data: any) =>
    request({
        url: `${formApi}/domain_data/delete`,
        method: 'post',
        data
    })

/**
 * 分页查询不带出form
 * @param data
 */
export const pageQueryDomainData = (data: any, headers?: any) =>
    request({
        url: `${formApi}/domain_data/pageQuery`,
        method: 'post',
        data,
        headers
    })

/**
 * 分页查询带出form
 * @param data
 */
export const pageQueryHaveFormDomainData = (data: any) =>
  request({
    url: `${formApi}/domain_data/pageQueryHaveForm`,
    method: 'post',
    data
  })

/**
 * 组合视图查询数据接口
 * @param data
 */
export const searchForCombination = (data: any) =>
  request({
    url: `${formApi}/domain_data/searchForCombination`,
    method: 'post',
    data
  })

/**
 * 组合视图查询table多表关联的数据接口
 * @param data
 */
export const searchForCombinationTable = (data: any) =>
  request({
    url: `${formApi}/domain_data/searchForCombinationTable`,
    method: 'post',
    data
  })

/**
 * 分页查询
 * @param data
 */
export const searchDomainData = (data: any) =>
    request({
        url: `${formApi}/domain_data/search`,
        method: 'post',
        data
    })
/**
 * 获取流程对应下面所有的表单数据
 * @param data
 */
export const queryDomainDataByFormIdList = (data: any) =>
    request({
        url: `${formApi}/domain_data/queryDomainDataByFormIdList`,
        method: 'post',
        data
    })
/**
 * 批量修改form数据
 */
export const updateDataOfForms = (data: any) =>
  request({
    url: `${formApi}/domain_data/batchUpdate`,
    method: 'post',
    data
  })

/**
 * 批量新增表单数据
 * @param data
 */
export const batchInsert = (data: any) =>
  request({
    url: `${formApi}/domain_data/batchInsert`,
    method: 'post',
    data
  })

/**
 * 根据条件批量删除表单数据
 * @param data
 */
export const batchDelete = (data: any) =>
  request({
    url: `${formApi}/domain_data/batchDelete`,
    method: 'post',
    data
  })

/**
 * 根据条件批量处理导入数据模式为更新、更新或追加
 * @param data
 */
export const batchUpdateOrAppend = (data: any) =>
  request({
    url: `${formApi}/domain_data/batchUpdateOrAppend`,
    method: 'post',
    data
  })

/**
 * 根据条件统计数据
 * @param data
 */
export const queryCount = (data: any) =>
  request({
    url: `${formApi}/domain_data/count`,
    method: 'post',
    data
  })

/**
 * 批量删除
 * @param data
 */
export const deleteDomainDataByFields = (data: any) =>
  request({
    url: `${formApi}/domain_data/deleteByFields`,
    method: 'post',
    data
  })



/**
 * 批量新增
 * @param data
 */
export const batchInsertWithFun = (data: any) =>
  request({
    url: `${formApi}/domain_data/batchInsertWithFun`,
    method: 'post',
    data
  })


/**
 * 批量更新
 * @param data
 */
export const batchUpdateWithFun = (data: any) =>
  request({
    url: `${formApi}/domain_data/batchUpdateWithFun`,
    method: 'post',
    data
  })


/**
 * 批量删除
 * @param data
 */
export const batchDeleteWithFun = (data: any) =>
request({
  url: `${formApi}/domain_data/batchDeleteWithFun`,
  method: 'post',
  data
})

/**
 * 根据数据id查询数据
 * @param data
 */
export const getDomainDataById = (data: any) =>
request({
  url: `${formApi}/domain_data/getDomainDataById`,
  method: 'post',
  data
})

export const searchLeftUnionTable = (data: any) =>
  request({
    url: `${formApi}/domain_data/searchLeftUnionTable`,
    method: 'post',
    data
  })



export const getDomainDataByProcess = (data: any) =>
  request({
    url: `${formApi}/domain_data/getDomainDataByProcess`,
    method: 'post',
    data
  })
